import React, { Component } from "react";
import { Spinner } from "Utils/SvgIcons";

class OverlaySpinner extends Component {
  render() {
    const { loading = true, label } = this.props;

    if (!loading) {
      return null;
    }
    return (
      <div className="overlay modalSpinner">
        <div className="spinner">
          <Spinner />
          {label && <p>{label}</p>}
        </div>
      </div>
    );
  }
}

export default OverlaySpinner;
